@if (!hideEmpty || editMode || (data && data.length > 0)) {
  <div
    class="cw-flex-row cw-input"
    ngModelGroup="{{ formModelGroup }}">
    <!-- Bezeichnung (nur falls "label" vorhanden) -->
    @if (label) {
      <label
        class="cw-input-label multiple-lines"
        [ngClass]="{'line-height': editMode}"
        for="{{ data && data.length - 1 }}"
        >{{ label }}
      </label>
    }
    <div class="cw-flex-column" [ngClass]="{'cw-editMode': editMode}">
      @if (editMode || (data && data.length > 0)) {
        <div class="cw-flex-row row-header">
          @if (editMode) {
            <div class="locked-header">
              @if (editMode) {
                <span>{{ 'MODULES.INSTITUTIONS.DATA.SUPPLEMENTARYNUMBERS.LOCKED' | translate }}</span>
              }
            </div>
          }
          <div class="cw-supplementary-number">
            {{ 'MODULES.INSTITUTIONS.DATA.SUPPLEMENTARYNUMBERS.NUMBER' | translate }}
          </div>
          <div class="cw-additional-note1">
            {{ 'MODULES.INSTITUTIONS.DATA.SUPPLEMENTARYNUMBERS.ADDITIONALNOTE1' | translate }}
          </div>
          <div class="cw-additional-note2">
            {{ 'MODULES.INSTITUTIONS.DATA.SUPPLEMENTARYNUMBERS.ADDITIONALNOTE2' | translate }}
          </div>
          @if (editMode && allowNewNumber && allowEditNumberValue) {
            <div class="cw-flex-row cw-button-wrapper">
              <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
              <button class="icon-plus cw-toolbar-icon" type="button" (click)="addElement()"></button>
            </div>
          }
        </div>
      }
      @for (row of data; track row; let i = $index; let isLast = $last; let isFirst = $first) {
        <!-- Element für Formular (hidden) -->
        <input type="hidden" id="{{ i }}" name="{{ i }}" [ngModel]="row" />
        @if (row.deleted !== 'Y') {
          <div class="cw-flex-row input-container">
            @if (editMode) {
              <phscw-input-single-checkbox
                [editMode]="editMode"
                name="locked_{{ i }}"
                inputId="locked_{{ i }}"
                [disabled]="!allowEditNumber"
                [(ngModel)]="row.locked"
              [showCheckbox]="true"></phscw-input-single-checkbox>
            }
            @if (!editMode && row.locked) {
              <span class="locked">
                <fa-icon class="locked-icon" icon="x"></fa-icon>
              </span>
            }
            <phscw-input-text
              class="cw-supplementary-number"
              [editMode]="editMode"
              name="supplementary_number_{{ i }}"
              inputId="supplementary_number_{{ i }}"
              [disabled]="!allowEditNumber || !allowEditNumberValue"
            [(ngModel)]="data[i].supplementary_number"></phscw-input-text>
            <phscw-input-text
              class="cw-additional-note1"
              [editMode]="editMode"
              name="additional_note1_{{ i }}"
              inputId="additional_note1_{{ i }}"
              [disabled]="!allowEditNumber"
            [(ngModel)]="data[i].additional_note1"></phscw-input-text>
            <phscw-input-text
              class="cw-additional-note2"
              [editMode]="editMode"
              name="additional_note2_{{ i }}"
              inputId="additional_note2_{{ i }}"
              [disabled]="!allowEditNumber"
            [(ngModel)]="data[i].additional_note2"></phscw-input-text>
            <!-- Steuerelemente zum hinzufügen und entfernen von Reihen -->
            @if (editMode && allowDeleteNumber) {
              <div class="cw-flex-row cw-button-wrapper">
                <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
                <button class="icon-minus cw-toolbar-icon" type="button" (click)="removeElement(i)"></button>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
}
